import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import PoloShirtCatalog from "./components/PoloShirtCatalog";
import RestaurantChefSection from "./components/RestaurantChefSection";
import ServicesSection from "./components/ServicesSection";
import EmbroideryShowcase from "./components/EmbroideryShowcase";
import IndustriesSection from "./components/IndustriesSection";
import OurWorkSection from "./components/OurWorkSection";
import TrustedClientsSection from "./components/TrustedClientsSection";
import AboutUsSection from "./components/AboutUsSection";
import ContactSection from "./components/ContactSection";
import WhatsAppButton from "./components/WhatsAppButton";
import CataloguePage from "./components/CataloguePage";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <PoloShirtCatalog />
        <RestaurantChefSection />
        <ServicesSection />
        <EmbroideryShowcase />
        <OurWorkSection />
        <IndustriesSection />
        <TrustedClientsSection />
        <AboutUsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
};

const CatalogueRoute = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <CataloguePage />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogue" element={<CatalogueRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
